import React from 'react'

import { getAuth, signOut } from "firebase/auth";
import useAuth from '../context/hook/useAuth';

//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'
import { Link } from 'react-router-dom';

export const MiniHeader = () => {

    const {dispatch} = useAuth()

    const userSignOut = getAuth();

    const hanldeClick = async (e) => {

        try {
            
            signOut(userSignOut).then(() => {
                localStorage.removeItem("cthash")
                dispatch({
                    type: "LOGOUT",
                })
                setTimeout(()=>{
                    //this is used to redirect to login after the registered in successfully
                    // window.location.href="/login"
                    window.location.href="/login"
                },2000)
                toast.success("Sign-out successful",{position:'top-right'})
            // Sign-out successful.
            }).catch((error) => {
                console.log(error)
            // An error happened.
            }); 
        } catch (error) {
            console.log(error)
        }
    }

  return (
    <>    
        <Link style={{cursor:'pointer'}} onClick={hanldeClick} >Logout</Link>
    </>
  )
}
